import React, { useRef, useState, useContext, useEffect } from "react";
import moment from "moment";

import creditCardIcon from "./resources/creditCard.png";
import simulationIcon from "../../../common/simulation/simulation.png";
import bankIcon from "./resources/bank.png";
import RangePicker from "../../../../components/RangePicker";
import { AppContext } from "../../../../AppContext";
import { getMonthIdAndYearFromTime } from "../../../Util";

export default function TransactionItemOverview(props) {
    const { updateTransactionSimulation, simulatedTransactions, getTransactionSimulation } = useContext(AppContext);

    const item = {
        id: props.item.id,
        time: props.item.time,
        parsedTime: moment(props.item.time).format("DD-MM-YY"),
        description: props.item.description,
        amount: props.item.amount,
        totalAmount: props.item.totalAmount,
        isCredit: props.item.isCredit,
        type: props.item.type,
        transactionType: props.transactionType,
        remarks: props.item.remarks
    };

    useEffect(() => {
        const { monthId, year } = getMonthIdAndYearFromTime(item.parsedTime);
        const relevantSimulatedTransactions = getTransactionSimulation(year, monthId);

        const simulatedTransaction = relevantSimulatedTransactions[item.id];
        if (simulatedTransaction) {
            if (simulatedTransaction.isCredit) {
                setAmount(simulatedTransaction.changedAmount);
            } else {
                setAmount(simulatedTransaction.changedAmount * -1);
            }
            setIsSimulated(true);
        } else {
            setIsSimulated(false);
            setAmount(item.amount);
        }
    }, [simulatedTransactions]);

    const rangePickerRef = useRef(null);
    const [amount, setAmount] = useState(item.amount);
    const [isSimulated, setIsSimulated] = useState(false);

    const rangeChanged = (changedAmount) => {
        updateTransactionSimulation({
            id: item.id,
            transactionType: item.transactionType,
            isCredit: item.isCredit,
            originalAmount: item.amount,
            changedAmount: Number(changedAmount),
            time: item.time
        });
    };

    const simulate = () => {
        rangePickerRef.current.show();
    };

    const amountColor = item.isCredit ? "#23d188" : "#ed578b";
    const transactionIcon = item.type === "Account" ? bankIcon : creditCardIcon;

    return (
        <div
            onClick={simulate}
            style={{
                display: "flex",
                direction: "RTL",
                justifyContent: "space-between"
            }}
        >
            <div style={{ display: "flex", width: "100%" }}>
                <img src={transactionIcon} style={{ height: "30px", marginRight: "8%" }} />
                <div style={{ width: "100%", marginRight: "10px" }}>
                    <h5 style={{ margin: "5px" }}>
                        <b>{item.description}</b>
                    </h5>
                    <h5
                        style={{
                            color: "darkgray",
                            fontWeight: "bold",
                            margin: "5px"
                        }}
                    >
                        {item.parsedTime}
                    </h5>
                </div>
            </div>

            <RangePicker
                data={item}
                amount={Math.abs(amount)}
                max={Math.abs(item.amount)}
                ref={rangePickerRef}
                rangeChanged={rangeChanged}
            />

            <h4
                style={{
                    color: amountColor,
                    direction: "ltr",
                    marginLeft: "5%",
                    width: "100%",
                    fontSize: "17px"
                }}
            >
                {amount}₪
                {isSimulated && <img src={simulationIcon} style={{ height: "20px", marginLeft: "8%" }} />}
            </h4>
        </div>
    );
}
